import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  body {
    margin: 0 !important;
    padding: 0;
  }
  
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace !important;
  }
  
  html {
    box-sizing: border-box !important;
  }
  
  *,
  *:before,
  *:after {
    box-sizing: inherit !important;
  }
  canvas, body, html {
    width: 100%;
    height: 100%;
    
  }

  #root{
    font-family: 'Fjalla One', serif !important;
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
  }
  
  #global-modal-container {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    touch-action: none;
    overflow: hidden;
    z-index: 100000;
    > div {
      pointer-events: auto;
    }
  }
  
  .modal {
    z-index: 10000;
  }

  .custom-carusel{
    display: flex;
    margin: 0 10px;
    align-items: flex-start;
  }
  .custom-carusel-btn{
     background-color: transparent;
     position: relative;
     padding-top: 3px;
     margin: 0 5px;
     border: none;
     top: -4px;
  }
  .custom-carusel-btn:disabled{
    opacity: 0.5;
  }
  @media(max-width: 1024px){
    .custom-carusel{
        width: 100%;
        z-index: 1;
        margin: 0;
        position: absolute;
    }
    .custom-carusel-btn{
        top: -5px;
        position: relative;
    }
  }
`;
